import React from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductLayoutWidgets from 'data-hooks/useProductLayoutWidgets';
import { PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPPrice from 'data-hooks/usePDPPrice';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import PDPKeySellingPointsUI from './PDPKeySellingPointsUI';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';

const PDPKeySellingPoints = () => {
  const { loading, error, data } = usePDPBasicDetails();

  const {
    loading: layoutWidgetLoading,
    data: layoutWidgetData,
  } = useProductLayoutWidgets();

  const {
    data: { isClearance },
  } = usePDPClearanceData();

  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const { data: priceData } = usePDPPrice();
  const { isClearance: priceClearance, clearanceStockPerSKU } = priceData || {};
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;

  if ((!data && loading) || (!layoutWidgetData && layoutWidgetLoading)) {
    return <PDPKeySellingPointsUI loading />;
  }

  if (error) {
    return 'Something went wrong, please try again';
  }

  const widgets = {};

  if (
    layoutWidgetData?.layout_widgets &&
    layoutWidgetData?.layout_widgets.length
  ) {
    layoutWidgetData?.layout_widgets.forEach(l => {
      widgets[l.widget_identifier] = l.fields;
    });
  }
  if (
    priceClearance &&
    clearanceStockPerSKU?.flashSale === '0' &&
    !isDecideLaterTab
  )
    return null;

  return (
    <PDPKeySellingPointsUI
      type={data?.type}
      efg_flag={data?.efg_flag}
      difficulty={data?.difficulty}
      is_external={data?.is_external}
      category_ids={data?.category_ids}
      fields={widgets.product_description}
      showClearanceWarning={isClearance}
      campaign={data?.custom_properties?.campaign}
    />
  );
};

export default PDPKeySellingPoints;
